// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Rba-z","colorTextValue":"Sba-z","swatches":"Tba-z","collapseLink":"Uba-z","isCollapsed":"Vba-z","dropdown":"Wba-z","disabled":"Xba-z"};